<template>
    <div class="OOP-match__holder" :class="{ 'OOP-match__holder--f' : followed(match.notBefore) }">

        <div class="OOP-match__before">
            {{displayNotBefore(match.notBefore)}}
        </div>

        <div class="OOP-match">

            <div class="OOP-match__player__holder" :class="{ 'reverse': shouldReverse(match) == true }">

                <div v-for="team in match.team" class="OOP-match__player" :class="[finished(match) ? 'def' : 'vs']">

                    <div class="OOP-match__player__info__holder">

                        <div v-for="player in team.players" class="OOP-match__player__info"
                             :data-id="player.id" v-if="player.id != 'TBD' && team.playersKnown == true">

                            <img v-if="player.country" class="small-flag" :src="flagPath + player.country.toLowerCase() + '.svg'"
                                 :alt="player.country">

                            {{ player.first }} {{ player.last }}

                            <span class="OOP-match__player__seed" v-if="team.seed">[{{ team.seed }}]</span>
                            <span class="OOP-match__player__seed" v-if="showType( 'q', player.id )">[Q]</span>
                            <span class="OOP-match__player__seed" v-if="showType( 'wc', player.id )">[WC]</span>

                        </div>

                        <div class="OOP-match__player__info" v-else-if="team.teamCode == 'Alternate'">
                            Alternate
                        </div>

                        <div class="OOP-match__player__info" v-else>TBD</div>

                    </div>

                </div>

            </div>

            <div class="OOP-match__meta">

                <div class="OOP-match__status" v-if="roundDisplay( match ) != ''">{{ roundDisplay( match ) }}</div>

                <div class="OOP-match__status">{{ determineStatus(match) }}</div>

                <a class="OOP-match__link" :href="detail + '?match=' + match.id" v-if="showStat(match)">
                    Match Stats
                </a>

            </div>

        </div>

    </div>
</template>

<script>

import moment from 'moment'

    export default {
        props: [ 'match', 'flagPath', 'type', 'detail', 'events' ],
        data() {
            return {
                ico_pointer_right: ico_pointer_right,
                //ico_ticket: ico_ticket,
            }
        },
        created() {
        },
        methods: {
            showStat(match) {
                return this.determineShowStat(match)
            },
            determineStatus(match) {

                // console.log(match.team[0].teamCode);



                if (match.status == 'Finished') {
                    return match.status
                }

                if (match.detail == '' || match.detail.state == 'upcoming' || match.detail.state == '' ) {
                    return 'Upcoming'
                }

                if (match.detail.state == 'W') {
                    return 'Warmup'
                }

                if (match.detail.state == 'C') {
                    return 'On court'
                }

                if (match.detail.state == 'F') {
                    return 'finished'
                }

                if (match.detail.state == 'P') {
                    return 'in progress'
                }

                if (match.detail.state == 'M') {
                    return 'in progress'
                }

                if (match.detail.state == 'G') {
                    return 'Players Arrived'
                }

                if (match.detail.state == 'T') {
                    return 'Time Announcement'
                }

                return '-'

            },
            determineShowStat(match) {

                if (match.status == 'Finished') {
                    return true
                }

                if (match.detail.state == 'F' || match.detail.state == 'P') {
                    return true
                }

                return false
            },
            displayNotBefore(notBefore) {

                if (notBefore.text != '' && notBefore.isoTime != '') {
                    return notBefore.text + ' ' + this.parseTime(notBefore.isoTime)
                }

                if (notBefore.text == notBefore.time) {
                    return notBefore.time
                }

                if(notBefore.time == '' && notBefore.isoTime != '' ){
                    return notBefore.text + ' ' + this.parseTime(notBefore.isoTime)
                }

                if (notBefore.text == 'Not Before' && notBefore.time != '') {
                    return notBefore.time
                }

                return `${notBefore.text}  ${notBefore.time}`

            },

            parseTime( isoTime ){
                var time = new moment(isoTime, 'HH:mm:ss')

                return time.format( 'h:mm a' )
            },

            followed(notBefore) {

                if (notBefore.text == 'Followed By') {
                    return true
                }

                return false

            },
            finished(match) {
                if (match.status == 'Finished') {
                    return true
                }

                if (match.detail != '' && match.detail.state == 'F') {
                    return true
                }

                return false
            },
            shouldReverse(match) {

                if ( match.detail.winner == undefined || match.detail.winner == '0' ) {
                    return false
                }

                if ( match.detail.winner == '2' || match.detail.winner == '4' || match.detail.winner == '6' ) {
                    return false
                }

                return true
            },
            roundDisplay( match ) {

                if ( match.detail.length == 0 ) {
                    return this.eventsRoundDisplay( match.id )
                }

                let round = match.detail.rnd

                if (this.type == 'wta') {
                    if ( round == '1' || round == 'R1' )
                        return 'R32'
                    else if (round == '2' || round == 'R2' )
                        return 'R16'
                    // else if (round == '3' || round == 'R3' )
                    //     return 'R16'

                    if (round == 'Q' )
                        return 'Quarterfinals'
                    else if (round == 'S')
                        return 'Semifinals'
                    else if (round == 'F')
                        return 'Final'
                } else {
                    if ( match.detail.isDoubles == '1' ) {

                        if ( round == '1' )
                            return 'R16'

                    } else {
                        if ( round == '1' || round == 'R1' )
                            return 'R64'
                        else if (round == '2' || round == 'R2' )
                            return 'R32'
                        else if (round == '3' || round == 'R3' )
                            return 'R16'
                    }

                    if (round == '5')
                        return 'Quarterfinals'
                    else if (round == '6')
                        return 'Semifinals'
                    else if (round == '7')
                        return 'Final'
                }

                if ( round == 'Q1' )
                    return 'Round 1'
                else if ( round == 'Q2' || round == 'Q4' )
                    return 'Round 2'

                return round;
            },
            eventsRoundDisplay( match_id ) {
                let rnd

                this.events.forEach( function( ev ) {
                    Object.entries( ev.rounds ).forEach( round => {
                        if ( round[1].length > 0 && round[1].includes( match_id ) )
                            rnd = round[0]
                    })
                })

                return this.parseDrawsRound( rnd );
            },
            parseDrawsRound( round ) {

                // if ( round == 'R32' )
                //     return 'Round 1'
                // else if ( round == 'R16' )
                //     return 'Round 2'
                // else
                //     return round
                return round

            },
            findPlayerById(playerId) {
                if ( playerId == '' )
                    return false

                let found = window.all_players.filter(player => player.player_id == playerId)

                if (found.length >= 1)
                    return found[0]

                return false
            },
            showType( type, playerId ) {
                let player = this.findPlayerById( playerId )

                if ( type == 'wc' && player.iswildcard == '1' )
                    return true
                else if ( type == 'q' && player.isqualifier == '1' )
                    return true

                return false;
            }
        }
    }
</script>
